import React from 'react';

interface AccessAppsModalProps {
  open: boolean;
  onClose: () => void;
}

const AccessAppsModal: React.FC<AccessAppsModalProps> = ({ open, onClose }) => {

  if (!open) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleCandidateLogin = () => {
    // Open candidate login page in a new tab
    window.open('/candidate-login', '_blank', 'noopener,noreferrer');
    onClose();
  };

  const handleEmployeeLogin = () => {
    // Open login page in a new tab
    window.open('/login', '_blank', 'noopener,noreferrer');
    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm animate-fadeIn"
      onClick={handleBackdropClick}
    >
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
      <style>{`
        .access-apps-modal-option {
          font-family: 'Inter', sans-serif;
          font-weight: 500;
          letter-spacing: -0.01em;
          line-height: 1.5;
        }
        .access-apps-modal-option:hover {
          font-weight: 600;
        }
      `}</style>
      <div
        className="bg-white rounded-lg shadow-2xl w-full max-w-md transform transition-all animate-slideUp"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <div className="flex justify-end p-4 pb-0">
          <button
            type="button"
            onClick={onClose}
            className="p-2 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
            aria-label="Close"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="px-6 sm:px-8 pb-6 sm:pb-8">
          <div className="text-center mb-6 sm:mb-8">
            <h2 className="text-xl sm:text-2xl font-bold text-blue-600 mb-4">
              Club Corners
            </h2>
          </div>
          
          <div className="bg-white border border-gray-400 overflow-hidden shadow-sm">
            {/* Recruiting Candidate Log In */}
            <button
              type="button"
              onClick={handleCandidateLogin}
              className="w-full px-4 sm:px-6 py-4 sm:py-5 text-left flex items-center justify-between hover:bg-gray-50 active:bg-gray-100 transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              <span className="access-apps-modal-option text-sm sm:text-base text-gray-900">
                Recruiting Candidate Log In
              </span>
              <svg
                className="w-5 h-5 text-gray-500 flex-shrink-0 ml-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
            
            {/* Divider */}
            <div className="border-t border-gray-400"></div>
            
            {/* HRMS Employee Log In */}
            <button
              type="button"
              onClick={handleEmployeeLogin}
              className="w-full px-4 sm:px-6 py-4 sm:py-5 text-left flex items-center justify-between hover:bg-gray-50 active:bg-gray-100 transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              style={{ userSelect: 'none' }}
            >
              <span className="access-apps-modal-option text-sm sm:text-base text-gray-900">
                HRMS Employee Log In
              </span>
              <svg
                className="w-5 h-5 text-gray-500 flex-shrink-0 ml-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessAppsModal;

